import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useParams } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import {
    combinarPacientesYEmpresas,
    filtrarPacientesParaModal,
    getNombreClienteFacturacion,
} from "../../../utils/busquedaPacienteFacturacion";
import { getTodayInputDate } from '../superadmin/superadminDateUtils';

function EditarPresupuesto() {
    const { id } = useParams();
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    // Estados del formulario
    const [fechaCreacion, setFechaCreacion] = useState(getTodayInputDate());
    const [fechaVence, setFechaVence] = useState('');
    const [numeroPresupuesto, setNumeroPresupuesto] = useState('');
    const [formaPago, setFormaPago] = useState('Efectivo');
    const [profesional, setProfesional] = useState('');
    const [profesionales, setProfesionales] = useState([]);
    
    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');
    
    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [valorBruto, setValorBruto] = useState(0);
    const [valorTotal, setValorTotal] = useState(0);
    
    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [buscarServicio, setBuscarServicio] = useState('');
    const [mostrarOpcionesServicio, setMostrarOpcionesServicio] = useState(false);
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);
    
    // Estados del presupuesto (saldo activo)
    const [estado, setEstado] = useState(0);
    const [saldoDisponible, setSaldoDisponible] = useState(0);
    const [valorConsumido, setValorConsumido] = useState(0);
    const [transicionLoading, setTransicionLoading] = useState(false);

    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;

    const calcularBaseConDescuentoItem = (item) => {
        const precio = parseFloat(item.precio) || 0;
        const cantidad = parseFloat(item.cantidad) || 0;
        const porcentaje = parseFloat(item.porcentaje) || 0;
        const precioBase = precio * cantidad;
        const descuento = precioBase * (porcentaje / 100);
        return precioBase - descuento;
    };

    const calcularBaseAjustadaItem = (item) => {
        const baseConDescuento = calcularBaseConDescuentoItem(item);
        const ajuste = parseFloat(item.ajuste) || 0;
        return baseConDescuento + ajuste;
    };

    const calcularTotalItem = (item) => {
        const baseAjustada = calcularBaseAjustadaItem(item);
        const impuestoPct = parseFloat(item.impuesto) || 0;
        const impuesto = baseAjustada * (impuestoPct / 100);
        return baseAjustada + impuesto;
    };

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar profesionales
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log('err profesionales: ' + error);
            });

        // Cargar datos del presupuesto
        axios.get('/presupuesto/' + id + '?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    const presupuesto = response.data;
                    setFechaCreacion(getTodayInputDate());
                    setFechaVence(presupuesto.fecha_vence);
                    setNumeroPresupuesto(presupuesto.numero_presupuesto);
                    setFormaPago(presupuesto.forma_pago);
                    setProfesional(presupuesto.users_id || '');
                    setPacienteId(presupuesto.paciente_id);
                    setValorBruto(presupuesto.valor_bruto);
                    setValorTotal(presupuesto.valor_total);
                    setObservaciones(presupuesto.observaciones || '');
                    setEstado(presupuesto.estado ?? 0);
                    setSaldoDisponible(parseFloat(presupuesto.saldo_disponible) || 0);
                    setValorConsumido(parseFloat(presupuesto.valor_consumido) || 0);
                    
                    // Cargar detalles con información de lista de precios
                    const productosConDetalle = presupuesto.detalle.map(detalle => ({
                        id: detalle.id,
                        id_listadeprecios: detalle.id_listadeprecios,
                        codigo: detalle.lista_precio?.codigo || '',
                        clasificacion: detalle.lista_precio?.clasificacion || '',
                        servicio: detalle.lista_precio?.nombre || '',
                        descripcion: detalle.descripcion || '',
                        cantidad: detalle.cantidad,
                        precio: parseFloat(detalle.precio_unitario),
                        porcentaje: parseFloat(detalle.porcentaje),
                        impuesto: parseFloat(detalle.impuesto),
                        ajuste: parseFloat(detalle.ajuste) || 0,
                        total: parseFloat(detalle.total)
                    }));
                    setProductos(productosConDetalle);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes y empresas (misma lógica que CrearFactura / presupuesto)
        Promise.all([
            axios.get('/pacientes', { ...config, params: { uid: userdata.user_id } }),
            axios.get('/pacientes', { ...config, params: { uid: userdata.user_id, solo_empresas: true } }),
        ])
            .then(([respPacientes, respEmpresas]) => {
                setPacientes(combinarPacientesYEmpresas(respPacientes, respEmpresas));
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos', config)
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, [id]);

    useEffect(() => {
        if (pacienteId && pacientes.length > 0) {
            const paciente = pacientes.find(p => p.id === pacienteId);
            if (paciente) {
                const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
                setNombrePaciente(nombreCompleto);
                setTipoPaciente(paciente.tipo_documento || 'CC');
                setDocumentoPaciente(paciente.numero_documento || '');
            }
        }
    }, [pacienteId, pacientes]);

    const getClasificacionesDinamicas = () => {
        const clasificaciones = Array.from(
            new Set(
                listaPrecios
                    .map(item => (item.clasificacion || '').trim())
                    .filter(Boolean)
            )
        );
        return clasificaciones.sort((a, b) => a.localeCompare(b));
    };

    const getListaPreciosFiltrada = () => {
        let filtrada = listaPrecios;

        if (clasificacionFiltro) {
            filtrada = filtrada.filter(item => item.clasificacion === clasificacionFiltro);
        }

        if (buscarServicio.trim()) {
            const term = buscarServicio.toLowerCase();
            filtrada = filtrada.filter(item =>
                (item.nombre || '').toLowerCase().includes(term) ||
                (item.codigo || '').toLowerCase().includes(term)
            );
        }

        return filtrada;
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                clasificacion: servicio.clasificacion || '',
                servicio: servicio.nombre,
                descripcion: '',
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                ajuste: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
            setBuscarServicio('');
            setMostrarOpcionesServicio(false);
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarTextoProducto = (id, campo, valor) => {
        const texto = String(valor ?? '').slice(0, 120);
        setProductos(productos.map((p) => (p.id === id ? { ...p, [campo]: texto } : p)));
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                if (campo === 'ajuste') {
                    // Permite escritura temporal de "-" en el input sin forzar 0.
                    const productoActualizado = { ...p, ajuste: String(valor ?? '') };
                    const ajusteNumerico = parseFloat(productoActualizado.ajuste);
                    const baseConDescuento = calcularBaseConDescuentoItem(productoActualizado);
                    const ajusteMinimo = -baseConDescuento;
                    if (Number.isFinite(ajusteNumerico) && ajusteNumerico < ajusteMinimo) {
                        productoActualizado.ajuste = ajusteMinimo;
                    }
                    productoActualizado.total = calcularTotalItem(productoActualizado);
                    return productoActualizado;
                }
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                productoActualizado.total = calcularTotalItem(productoActualizado);
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let subtotal = 0;
        let totalDescuentos = 0;
        let totalImpuestos = 0;
        let total = 0;

        productosArray.forEach(producto => {
            const precioBase = producto.precio * producto.cantidad;
            const descuento = precioBase * (producto.porcentaje / 100);
            const ajuste = parseFloat(producto.ajuste) || 0;
            const baseConDescuento = precioBase - descuento;
            const baseAjustada = baseConDescuento + ajuste;
            const impuesto = baseAjustada * (producto.impuesto / 100);
            
            subtotal += precioBase;
            totalDescuentos += descuento;
            totalImpuestos += impuesto;
            total += parseFloat(producto.total ?? (baseAjustada + impuesto)) || 0;
        });

        setValorBruto(subtotal);
        setValorTotal(total);
    };

    const getNombreClientePresupuesto = getNombreClienteFacturacion;

    const getPacientesFiltrados = () =>
        filtrarPacientesParaModal(pacientes, busquedaPaciente);

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        const inicio = (paginaActual - 1) * pacientesPorPagina;
        const fin = inicio + pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = getNombreClienteFacturacion(paciente);
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setShowModalPaciente(false);
    };

    // --- Estado del presupuesto: helpers ---
    const estadoNombres = { 0: 'Generado', 1: 'Activo', 2: 'Anulado', 3: 'Pagado' };
    const esDeshabilitado = estado === 2 || estado === 3;
    const esActivo = estado === 1;
    const getEstadoBadgeStyle = (estadoActual) => {
        switch (estadoActual) {
            case 1: // Activo
                return { background: 'rgba(23, 162, 184, 0.10)', color: '#17a2b8', border: '1px solid rgba(23, 162, 184, 0.22)' };
            case 2: // Anulado
                return { background: 'rgba(220, 53, 69, 0.10)', color: '#dc3545', border: '1px solid rgba(220, 53, 69, 0.22)' };
            case 3: // Pagado
                return { background: 'rgba(40, 167, 69, 0.10)', color: '#28a745', border: '1px solid rgba(40, 167, 69, 0.22)' };
            case 0: // Generado
            default:
                return { background: 'rgba(108, 117, 125, 0.10)', color: '#6c757d', border: '1px solid rgba(108, 117, 125, 0.22)' };
        }
    };

    const getTransicionBotones = () => {
        const botones = [];
        if (estado === 0) botones.push({ label: 'Aprobar', nuevoEstado: 1, color: 'success', icon: 'fas fa-check' });
        if (estado === 1) botones.push({ label: 'Anular', nuevoEstado: 2, color: 'danger', icon: 'fas fa-ban' });
        return botones;
    };

    const handleCambiarEstado = async (nuevoEstado) => {
        const ref =
            numeroPresupuesto != null && String(numeroPresupuesto).trim() !== ''
                ? ` N° ${numeroPresupuesto}`
                : '';
        const mensajeConfirmacion =
            nuevoEstado === 2
                ? `¿Anular el presupuesto${ref}? Esta acción pondrá el saldo en $0 y no se podrá revertir.`
                : nuevoEstado === 1
                    ? `¿Aprobar el presupuesto${ref}? Quedará activo y podrá facturarse.`
                    : `¿Cambiar el estado del presupuesto${ref}?`;

        if (!window.confirm(mensajeConfirmacion)) return;

        setTransicionLoading(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        try {
            const response = await axios.put('/presupuesto/' + id + '/estado', { estado: nuevoEstado }, config);
            if (response.data.success) {
                setEstado(nuevoEstado);
                // Si se activó (0→1), actualizar saldo
                if (nuevoEstado === 1) {
                    setSaldoDisponible(parseFloat(valorTotal) || 0);
                    setValorConsumido(0);
                }
                // Si se anuló (1→2), solo resetear saldo pendiente, conservar consumido
                if (nuevoEstado === 2) {
                    setSaldoDisponible(0);
                    // valorConsumido se conserva
                }
                alert(response.data.message || 'Estado actualizado exitosamente');
            }
        } catch (error) {
            const msg = error.response?.data?.message || error.message;
            alert('Error al cambiar estado: ' + msg);
        } finally {
            setTransicionLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (esDeshabilitado) {
            alert('No se puede editar un presupuesto Pagado/Cancelado');
            return;
        }

        if (!pacienteId) {
            alert('Por favor seleccione un paciente');
            return;
        }
        
        if (productos.length === 0) {
            alert('Debe agregar al menos un servicio');
            return;
        }

        // Validar valor_total >= valor_consumido si está activo
        if (esActivo && parseFloat(valorTotal) < valorConsumido) {
            alert(`El valor total no puede ser menor al valor consumido ($${valorConsumido.toLocaleString('es-CO', {minimumFractionDigits: 2})}). Valor mínimo permitido: $${valorConsumido.toLocaleString('es-CO', {minimumFractionDigits: 2})}`);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        const presupuestoData = {
            users_id: parseInt(profesional),
            paciente_id: parseInt(pacienteId),
            client_id: client.client_id,
            fecha_creacion: fechaCreacion,
            fecha_vence: fechaVence,
            forma_pago: formaPago,
            valor_bruto: parseFloat(valorBruto),
            valor_total: parseFloat(valorTotal),
            observaciones: observaciones || '',
            detalle: productos.map(producto => ({
                id: producto.id > 1000000000000 ? null : producto.id, // IDs temporales son null para crear nuevos
                descripcion: (producto.descripcion || '').trim() || null,
                id_listadeprecios: parseInt(producto.id_listadeprecios),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                ajuste: parseFloat(producto.ajuste) || 0,
                total: parseFloat(producto.total)
            }))
        };

        try {
            const response = await axios.put('/presupuesto/' + id, presupuestoData, config);
            if (response.status === 200) {
                alert('Presupuesto actualizado exitosamente');
                // Si estaba activo y valor_total == valor_consumido, el backend lo cierra
                if (esActivo && parseFloat(valorTotal) === valorConsumido) {
                    setEstado(3);
                    setSaldoDisponible(0);
                } else if (esActivo) {
                    setSaldoDisponible(parseFloat(valorTotal) - valorConsumido);
                }
            }
        } catch (error) {
            console.error('Error completo:', error);
            const errorData = error.response?.data;
            let msg = errorData?.message || error.message;
            if (errorData?.valor_minimo !== undefined) {
                msg += `\nValor mínimo permitido: $${parseFloat(errorData.valor_minimo).toLocaleString('es-CO', {minimumFractionDigits: 2})}`;
            }
            alert('Error al actualizar el presupuesto: ' + msg);
        }
    };

    if (loggedIn) {
        return (
            <div className="hold-transition presupuesto-page">
                <style>{`
                    .presupuesto-page { font-size: 12.5px; }
                    .presupuesto-page .content-header h1 {
                        font-size: 1.95rem !important;
                        font-weight: 800 !important;
                        margin-bottom: 0 !important;
                    }
                    .presupuesto-page label {
                        font-size: 0.76rem;
                        font-weight: 700;
                        color: #6c757d;
                        margin-bottom: 6px;
                        text-transform: uppercase;
                        letter-spacing: .03rem;
                    }
                    .presupuesto-page .form-control {
                        font-size: 0.82rem !important;
                        padding: 0.38rem 0.68rem !important;
                        min-height: 36px;
                    }
                    .presupuesto-page .btn { font-size: 0.82rem !important; }
                    .presupuesto-soft-card {
                        border-radius: 16px !important;
                        border: 1px solid rgba(0,0,0,0.05) !important;
                        box-shadow: 0 10px 24px rgba(0,0,0,0.04) !important;
                    }
                    .presupuesto-soft-header {
                        background: #fff;
                        border-bottom: 1px solid rgba(0,0,0,0.06);
                    }
                    .budget-main-title {
                        margin: 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 1rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .budget-main-title .title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 9px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(23,162,184,0.1);
                        color: #17a2b8;
                        font-size: 0.85rem;
                    }
                    .budget-section-title {
                        margin: 0 0 14px 0;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 0.95rem;
                        font-weight: 800;
                        color: #323a45;
                    }
                    .budget-section-title .title-icon {
                        width: 26px;
                        height: 26px;
                        border-radius: 8px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(50,58,69,0.08);
                        color: #323a45;
                        font-size: 0.78rem;
                    }
                    .chip-row {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                    }
                    .chip-filter {
                        border: 1px solid rgba(23,162,184,0.25);
                        background: rgba(23,162,184,0.06);
                        color: #17a2b8;
                        border-radius: 999px;
                        padding: 5px 12px;
                        font-size: 0.75rem;
                        font-weight: 700;
                        cursor: pointer;
                    }
                    .chip-filter.active {
                        background: #17a2b8;
                        color: #fff;
                        border-color: #17a2b8;
                    }
                    .estado-pill {
                        display: inline-flex;
                        align-items: center;
                        border-radius: 999px;
                        padding: 4px 10px;
                        font-size: 0.68em;
                        font-weight: 800;
                        vertical-align: middle;
                    }
                    .saldo-soft {
                        border-radius: 14px;
                        border: 1px solid rgba(23,162,184,0.20);
                        background: linear-gradient(135deg, rgba(23,162,184,0.08) 0%, rgba(50,58,69,0.04) 100%);
                        padding: 12px 14px;
                    }
                    .saldo-item { padding: 4px 6px; }
                    .saldo-label {
                        font-size: 0.74rem;
                        font-weight: 700;
                        color: #6c757d;
                        text-transform: uppercase;
                        letter-spacing: .03rem;
                    }
                    .saldo-value {
                        margin: 2px 0 0 0;
                        font-size: 1.05rem;
                        font-weight: 800;
                        color: #323a45;
                        line-height: 1.2;
                    }
                    .factura-lineas-table .factura-col-accion-head,
                    .factura-lineas-table .factura-col-accion-body {
                        width: 44px;
                        min-width: 44px;
                        max-width: 44px;
                        padding: 6px 4px !important;
                        text-align: center;
                        vertical-align: middle !important;
                        white-space: nowrap;
                    }
                    .factura-total-label-cell {
                        border: none !important;
                        text-align: right;
                        vertical-align: middle !important;
                        padding: 3px 8px !important;
                        font-size: 0.72rem;
                        font-weight: 400;
                        color: #6c757d;
                        white-space: nowrap;
                        min-width: 96px;
                        line-height: 1.25;
                    }
                    .factura-total-value-cell {
                        border: none !important;
                        padding: 3px 0 !important;
                        vertical-align: middle !important;
                    }
                    .factura-total-value-input {
                        width: 100%;
                        max-width: 100%;
                        text-align: right;
                        font-size: 0.72rem;
                        font-weight: 400;
                        color: #495057;
                        background-color: #f8f9fa !important;
                        padding: 0.25rem 0.35rem !important;
                        min-height: 28px !important;
                    }
                    .factura-total-value-input.factura-total-final {
                        font-size: 0.75rem;
                        font-weight: 600;
                        color: #17a2b8;
                    }
                    .factura-lineas-table {
                        table-layout: fixed;
                        border-collapse: collapse;
                    }
                    .factura-lineas-table th,
                    .factura-lineas-table td {
                        border: none !important;
                    }
                    .factura-lineas-table {
                        font-size: 0.75rem;
                    }
                    .factura-lineas-table thead th {
                        border-bottom: 1px solid #dee2e6 !important;
                        padding-bottom: 8px;
                        font-size: 0.7rem;
                        font-weight: 600;
                        color: #6c757d;
                    }
                    .factura-lineas-table tfoot tr:first-child td {
                        border-top: 1px solid #e9ecef !important;
                        padding-top: 10px;
                    }
                    .factura-lineas-table .factura-col-servicio,
                    .factura-lineas-table .factura-col-descripcion {
                        text-align: center;
                        vertical-align: top;
                        font-size: 0.72rem;
                        padding: 6px 8px;
                        line-height: 1.3;
                        word-break: break-word;
                    }
                    .factura-lineas-table .factura-col-servicio {
                        min-width: 120px;
                        max-width: 180px;
                    }
                    .factura-lineas-table .factura-col-descripcion {
                        min-width: 110px;
                        max-width: 160px;
                    }
                    .factura-lineas-table .factura-input-descripcion {
                        width: 100% !important;
                        min-width: 0 !important;
                        min-height: 30px !important;
                        max-height: 4.5rem;
                        padding: 0.25rem 0.35rem !important;
                        font-size: 0.72rem !important;
                        line-height: 1.3;
                        resize: none;
                        overflow-wrap: anywhere;
                        word-break: break-word;
                        white-space: pre-wrap;
                    }
                    .factura-lineas-table .factura-col-cant,
                    .factura-lineas-table .factura-col-desc {
                        width: 72px;
                        max-width: 72px;
                    }
                    .factura-lineas-table .factura-col-precio {
                        width: 118px;
                        max-width: 118px;
                    }
                    .factura-lineas-table .factura-input-cant,
                    .factura-lineas-table .factura-input-desc {
                        width: 100% !important;
                        max-width: 64px !important;
                        min-width: 0 !important;
                        min-height: 32px !important;
                        padding: 0.28rem 0.35rem !important;
                        margin: 0 auto;
                        text-align: center;
                        -moz-appearance: textfield;
                    }
                    .factura-lineas-table .factura-input-precio {
                        width: 100% !important;
                        max-width: 110px !important;
                        min-height: 32px !important;
                        padding: 0.28rem 0.4rem !important;
                        text-align: right;
                        -moz-appearance: textfield;
                    }
                    .factura-lineas-table .factura-input-cant::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-cant::-webkit-inner-spin-button,
                    .factura-lineas-table .factura-input-desc::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-desc::-webkit-inner-spin-button,
                    .factura-lineas-table .factura-input-precio::-webkit-outer-spin-button,
                    .factura-lineas-table .factura-input-precio::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-presupuestos">Listado de Presupuestos</Link></li>
                                        <li className="breadcrumb-item active">Editar Presupuesto</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">
                                        Editar Presupuesto{' '}
                                        <span className="estado-pill" style={getEstadoBadgeStyle(estado)}>
                                            {estadoNombres[estado]}
                                        </span>
                                    </h1>
                                </div>
                                <div className="col-sm-4 text-right" style={{paddingTop: '8px'}}>
                                    {getTransicionBotones().map((boton, idx) => (
                                        <button
                                            key={idx}
                                            type="button"
                                            className={`btn btn-${boton.color} ml-2`}
                                            onClick={() => handleCambiarEstado(boton.nuevoEstado)}
                                            disabled={transicionLoading}
                                        >
                                            {transicionLoading ? (
                                                <><i className="fas fa-spinner fa-spin"></i> Procesando...</>
                                            ) : (
                                                <><i className={boton.icon}></i> {boton.label}</>
                                            )}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            <div className="card card-info card-outline presupuesto-soft-card">
                                <div className="card card-info-outline">
                                    <div className="card-header presupuesto-soft-header">
                                        <h5 className="budget-main-title">
                                            <span className="title-icon"><i className="fas fa-file-invoice"></i></span>
                                            Información del Presupuesto
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {/* Saldo info para presupuesto activo */}
                                        {esActivo && (
                                            <div className="saldo-soft">
                                                <div className="row">
                                                    <div className="col-md-4 saldo-item">
                                                        <div className="saldo-label">Saldo Pendiente</div>
                                                        <p className="saldo-value">
                                                            $ {parseFloat(saldoDisponible).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-4 saldo-item">
                                                        <div className="saldo-label">Valor Pagado</div>
                                                        <p className="saldo-value">
                                                            $ {parseFloat(valorConsumido).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-4 saldo-item">
                                                        <div className="saldo-label">Valor Mínimo Permitido</div>
                                                        <p className="saldo-value" style={{ color: '#6c757d' }}>
                                                            $ {parseFloat(valorConsumido).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Aviso para presupuesto pagado/cancelado */}
                                        {esDeshabilitado && (
                                            <div className="alert alert-danger">
                                                <i className="fas fa-lock mr-2"></i>
                                                Este presupuesto está <strong>{estadoNombres[estado]}</strong> y no se puede editar.
                                            </div>
                                        )}

                                        <form onSubmit={handleSubmit}>
                                            
                                            <h5 className="budget-section-title">
                                                <span className="title-icon"><i className="fas fa-user"></i></span>
                                                Información del Paciente
                                            </h5>
                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info"
                                                            style={{marginTop: '32px'}}
                                                            onClick={() => setShowModalPaciente(true)}
                                                            disabled={esDeshabilitado}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Fecha de Modificación *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fechaCreacion}
                                                            onChange={(e) => setFechaCreacion(e.target.value)}
                                                            required
                                                            disabled={esDeshabilitado}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Fecha de Vencimiento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fechaVence}
                                                            onChange={(e) => setFechaVence(e.target.value)}
                                                            required
                                                            disabled={esDeshabilitado}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Profesional *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={profesional}
                                                            onChange={(e) => setProfesional(e.target.value)}
                                                            required
                                                            disabled={esDeshabilitado}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {profesionales.map(prof => (
                                                                <option key={prof.id} value={prof.id}>{prof.name} {prof.lastname}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>N° Presupuesto</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={numeroPresupuesto}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label>Clasificación</label>
                                                        <div className="chip-row mb-2">
                                                            <button
                                                                type="button"
                                                                className={`chip-filter ${clasificacionFiltro === '' ? 'active' : ''}`}
                                                                onClick={() => setClasificacionFiltro('')}
                                                                disabled={esDeshabilitado}
                                                            >
                                                                Todas
                                                            </button>
                                                            {getClasificacionesDinamicas().map((clas) => (
                                                                <button
                                                                    key={clas}
                                                                    type="button"
                                                                    className={`chip-filter ${clasificacionFiltro === clas ? 'active' : ''}`}
                                                                    onClick={() => setClasificacionFiltro(clas)}
                                                                    disabled={esDeshabilitado}
                                                                >
                                                                    {clas}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-10">
                                                        <label>Selecciona el Servicio</label>
                                                        <div style={{ position: 'relative' }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Buscar y seleccionar servicio (código o nombre)..."
                                                                value={buscarServicio}
                                                                onFocus={() => !esDeshabilitado && setMostrarOpcionesServicio(true)}
                                                                onBlur={() => setTimeout(() => setMostrarOpcionesServicio(false), 150)}
                                                                onChange={(e) => {
                                                                    setBuscarServicio(e.target.value);
                                                                    setProductoSeleccionado('');
                                                                    if (!esDeshabilitado) setMostrarOpcionesServicio(true);
                                                                }}
                                                                disabled={esDeshabilitado}
                                                            />

                                                            {mostrarOpcionesServicio && !esDeshabilitado && (
                                                                <div
                                                                    className="shadow-sm"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        zIndex: 1000,
                                                                        width: '100%',
                                                                        maxHeight: '260px',
                                                                        overflowY: 'auto',
                                                                        background: '#fff',
                                                                        border: '1px solid #dee2e6',
                                                                        borderRadius: '10px',
                                                                        marginTop: '4px'
                                                                    }}
                                                                >
                                                                    {getListaPreciosFiltrada().length === 0 ? (
                                                                        <div style={{ padding: '10px 12px', color: '#8c8c8c', fontSize: '0.85rem' }}>
                                                                            No hay servicios para tu búsqueda.
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {getListaPreciosFiltrada().slice(0, 30).map(servicio => (
                                                                                <button
                                                                                    key={servicio.id}
                                                                                    type="button"
                                                                                    onMouseDown={() => {
                                                                                        setProductoSeleccionado(servicio.id);
                                                                                        setBuscarServicio(`${servicio.codigo || ''} - ${servicio.nombre || ''}`.trim());
                                                                                        setMostrarOpcionesServicio(false);
                                                                                    }}
                                                                                    style={{
                                                                                        display: 'block',
                                                                                        width: '100%',
                                                                                        textAlign: 'left',
                                                                                        border: 'none',
                                                                                        background: 'transparent',
                                                                                        padding: '8px 12px',
                                                                                        borderBottom: '1px solid #f3f3f3',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <span style={{ fontWeight: 600, color: '#323a45' }}>{servicio.codigo}</span>
                                                                                    <span style={{ color: '#8c8c8c' }}> - {servicio.nombre}</span>
                                                                                </button>
                                                                            ))}
                                                                            {getListaPreciosFiltrada().length > 30 && (
                                                                                <div style={{ padding: '8px 12px', color: '#8c8c8c', fontSize: '0.75rem', background: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                                                                                    Mostrando 30 de {getListaPreciosFiltrada().length} resultados. Escribe más para refinar.
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>&nbsp;</label>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info btn-block"
                                                            onClick={agregarServicio}
                                                            disabled={esDeshabilitado || !productoSeleccionado}
                                                        >
                                                            Agregar
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            {/* Tabla de productos */}
                                            <div className="table-responsive" style={{overflowX: 'auto'}}>
                                                <table className="table factura-lineas-table" style={{minWidth: '1080px'}}>
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center" style={{width: '11%', minWidth: '96px'}}>Clasificación</th>
                                                            <th className="text-center factura-col-servicio">Servicio</th>
                                                            <th className="text-center factura-col-descripcion">Descripción</th>
                                                            <th className="text-center factura-col-cant">Cant.</th>
                                                            <th className="text-center factura-col-precio">Precio</th>
                                                            <th className="text-center factura-col-desc">Desc %</th>
                                                            <th className="text-center" style={{width: '9%', minWidth: '88px'}}>Ajuste</th>
                                                            <th className="text-center" style={{width: '10%', minWidth: '95px'}}>Impuesto</th>
                                                            <th className="text-center" style={{width: '14%', minWidth: '120px'}}>Total</th>
                                                            <th className="text-center factura-col-accion-head"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productos.map(producto => (
                                                            <tr key={producto.id}>
                                                                <td>{producto.clasificacion || 'N/A'}</td>
                                                                <td className="factura-col-servicio">{producto.servicio}</td>
                                                                <td className="factura-col-descripcion">
                                                                    <textarea
                                                                        rows={2}
                                                                        className="form-control form-control-sm factura-input-descripcion"
                                                                        value={producto.descripcion || ''}
                                                                        maxLength={120}
                                                                        onChange={(e) => actualizarTextoProducto(producto.id, 'descripcion', e.target.value)}
                                                                        disabled={esDeshabilitado}
                                                                    />
                                                                </td>
                                                                <td className="text-center factura-col-cant">
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm factura-input-cant" 
                                                                        value={producto.cantidad}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                        min="1"
                                                                        max="999"
                                                                        disabled={esDeshabilitado}
                                                                    />
                                                                </td>
                                                                <td className="text-right factura-col-precio">
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm factura-input-precio" 
                                                                        value={producto.precio}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                        step="0.01"
                                                                        disabled={esDeshabilitado}
                                                                    />
                                                                </td>
                                                                <td className="text-center factura-col-desc">
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm factura-input-desc" 
                                                                        value={producto.porcentaje}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                        min="0"
                                                                        max="100"
                                                                        disabled={esDeshabilitado}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm"
                                                                        value={producto.ajuste ?? ''}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'ajuste', e.target.value)}
                                                                        step="0.01"
                                                                        min={-calcularBaseConDescuentoItem(producto)}
                                                                        disabled={esDeshabilitado}
                                                                    />
                                                                </td>
                                                                <td className="text-center">
                                                                    <select 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.impuesto}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                        disabled={esDeshabilitado}
                                                                        style={{ textAlign: 'center', textAlignLast: 'center' }}
                                                                    >
                                                                        <option value="0">0</option>
                                                                        {impuestos.map(imp => (
                                                                            <option key={imp.id} value={imp.impuesto}>{imp.nombre+' '+imp.impuesto+'%'}</option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td className="text-right">
                                                                    $ {parseFloat(producto.total || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                </td>
                                                                <td className="factura-col-accion-body">
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn p-0 border-0 bg-transparent text-danger"
                                                                        onClick={() => eliminarProducto(producto.id)}
                                                                        disabled={esDeshabilitado}
                                                                        title="Eliminar servicio"
                                                                    >
                                                                        <i className="fas fa-trash-alt"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">Subtotal:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control form-control-sm factura-total-value-input" 
                                                                    value={'$ ' + parseFloat(valorBruto || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">Descuento{'\u00A0'}:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control form-control-sm factura-total-value-input" 
                                                                    value={'$ ' + productos.reduce((sum, p) => sum + ((p.precio * p.cantidad) * (p.porcentaje / 100)), 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">Ajuste:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm factura-total-value-input"
                                                                    value={'$ ' + productos.reduce((sum, p) => sum + (parseFloat(p.ajuste) || 0), 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">IVA:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control form-control-sm factura-total-value-input" 
                                                                    value={'$ ' + productos.reduce((sum, p) => {
                                                                        const precioBase = (parseFloat(p.precio) || 0) * (parseFloat(p.cantidad) || 0);
                                                                        const descuento = precioBase * ((parseFloat(p.porcentaje) || 0) / 100);
                                                                        const baseAjustada = (precioBase - descuento) + (parseFloat(p.ajuste) || 0);
                                                                        return sum + (baseAjustada * ((parseFloat(p.impuesto) || 0) / 100));
                                                                    }, 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="7" style={{border: 'none'}}></td>
                                                            <td className="factura-total-label-cell">Total:</td>
                                                            <td className="factura-total-value-cell">
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control form-control-sm factura-total-value-input factura-total-final" 
                                                                    value={'$ ' + parseFloat(valorTotal || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                            <td style={{border: 'none'}}></td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea 
                                                    className="form-control" 
                                                    rows="5"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder=""
                                                    disabled={esDeshabilitado}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-info mr-2" disabled={esDeshabilitado}>
                                                    Actualizar Presupuesto
                                                </button>
                                                <Link to="/listado-presupuestos" className="btn btn-secondary">
                                                    Cancelar
                                                </Link>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal para seleccionar paciente */}
                {showModalPaciente && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar Paciente</h5>
                                    <button type="button" className="close" onClick={() => setShowModalPaciente(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group mb-3">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por nombre o documento..."
                                            value={busquedaPaciente}
                                            onChange={(e) => {
                                                setBusquedaPaciente(e.target.value);
                                                setPaginaActual(1);
                                            }}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            height: 'min(52vh, 420px)',
                                            overflowY: 'scroll',
                                            scrollbarGutter: 'stable',
                                        }}
                                    >
                                        <table className="table table-hover table-sm table-borderless mb-0">
                                            <thead className="thead-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Documento</th>
                                                    <th className="text-center" style={{ width: '56px' }}>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getPacientesPaginados().map((paciente) => (
                                                    <tr key={paciente.id ?? `${paciente.numero_documento}-${getNombreClientePresupuesto(paciente)}`}>
                                                        <td>{getNombreClientePresupuesto(paciente)}</td>
                                                        <td>{paciente.numero_documento}</td>
                                                        <td className="text-center align-middle">
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-sm btn-success"
                                                                title="Seleccionar paciente"
                                                                aria-label="Seleccionar paciente"
                                                                onClick={() => seleccionarPaciente(paciente)}
                                                            >
                                                                <i className="fas fa-check"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {getPacientesPaginados().length === 0 && (
                                                    <tr>
                                                        <td colSpan="3" className="text-center text-muted py-4">
                                                            No hay resultados para la búsqueda.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {/* Paginación */}
                                    {getTotalPaginas() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === 1}
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === getTotalPaginas()}
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalPaciente(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default EditarPresupuesto;